module.exports = __webpack_public_path__ + "static/media/perfect_logo.5c6e280f.svg";